import CardMedia from '@mui/material/CardMedia'
import Box from '@mui/material/Box'
import Grid from '@mui/material/Grid'
import Paper from '@mui/material/Paper'
import Typography from '@mui/material/Typography'
import DeleteIcon from '@mui/icons-material/Delete'
import IconButton from '@mui/material/IconButton'

interface Props {
  Name?: string
  LogoURL?: string
  UserId?: string
  onDelete?: () => void
}

export const WholesalerDetailsCard = ({ Name, LogoURL, UserId, onDelete }: Props) => {
  return (
    <Paper elevation={1}>
      <Box position='relative' minWidth='300px'>
        <Box>
          <Grid container justifyContent='space-between' alignItems='center' style={{ textAlign: 'center' }} spacing={1}>
            <Grid item xs={onDelete ? 5 : 7}>
              <Typography variant='body2' fontWeight='bold'>
                {Name}:
              </Typography>
              <Typography variant='body2'>{UserId}</Typography>
            </Grid>
            <Grid item xs={5}>
              <Box display='flex' justifyContent='center' padding={1} height='4.5em'>
                <CardMedia
                  component='img'
                  src={LogoURL}
                  sx={{
                    width: 'auto',
                    maxWidth: '100%',
                    'img&': {
                      objectFit: 'contain'
                    }
                  }}
                />
              </Box>
            </Grid>
            {onDelete && (
              <Grid item xs={2}>
                <IconButton aria-label='delete' color='info' onClick={onDelete} size='large'>
                  <DeleteIcon />
                </IconButton>
              </Grid>
            )}
          </Grid>
        </Box>
      </Box>
    </Paper>
  )
}
